// @ts-nocheck

import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

const Button = styled.button`
  && {
    :active {
      background-color: ${({ theme }) => theme.common.colors.lightest};
    }
  }
`;

const FastButton = (props) => {
  const { onClick } = props;
  const ref = useRef();

  useEffect(() => {
    const { current } = ref;
    const onTouchStart = (e) => {
      e.preventDefault();
      if (typeof onClick === 'function') {
        onClick();
      }
    };
    current.addEventListener('touchstart', onTouchStart);
    return () => {
      current.removeEventListener('touchstart', onTouchStart);
    };
  }, [onClick]);

  return (
    <Button ref={ref} style={props.style} className={props.className}>
      {props.children}
    </Button>
  );
};

export default FastButton;
